import React from 'react';
import {
	Box,
	Button,
	Container,
	Flex,
	Heading,
	HStack,
	Icon,
	SimpleGrid,
	Text,
	VStack,
} from '@chakra-ui/react';
import { FiArrowRight, FiCheckCircle, FiZap } from 'react-icons/fi';
import BlogsmithTypewriterDemo from './BlogsmithTypewriterDemo';
import FilmGrain from './FilmGrain';

export default function HomePageBlogsmithSpotlight({ onCta }) {
	return (
		<Box
			py={{ base: 16, md: 20 }}
			bg='linear-gradient(135deg, #1a1033 0%, #0d2847 50%, #0a3d4a 100%)'
			position='relative'
			overflow='hidden'
			id='blogsmith'>
			<FilmGrain opacity={0.035} />
			<Box
				position='absolute'
				top='-20%'
				right='-10%'
				w='400px'
				h='400px'
				bg='purple.500'
				filter='blur(120px)'
				opacity={0.25}
				borderRadius='full'
			/>
			<Box
				position='absolute'
				bottom='-20%'
				left='-5%'
				w='350px'
				h='350px'
				bg='cyan.400'
				filter='blur(100px)'
				opacity={0.2}
				borderRadius='full'
			/>

			<Container maxW='container.xl' position='relative' zIndex={1}>
				<SimpleGrid columns={{ base: 1, lg: 2 }} spacing={10} alignItems='center'>
					<VStack align={{ base: 'center', lg: 'start' }} spacing={5} textAlign={{ base: 'center', lg: 'left' }}>
						<HStack
							spacing={2}
							bg='whiteAlpha.100'
							px={4}
							py={1.5}
							rounded='full'
							border='1px solid'
							borderColor='whiteAlpha.200'>
							<Icon as={FiZap} color='cyan.300' />
							<Text fontSize='sm' color='cyan.200' fontWeight='semibold' mb={0}>
								Meet Blogsmith
							</Text>
						</HStack>
						<Heading
							size='2xl'
							color='white'
							fontWeight='extrabold'
							lineHeight='1.15'>
							AI that publishes SEO content to WordPress —{' '}
							<Text as='span' color='cyan.300'>
								on autopilot
							</Text>
						</Heading>
						<Text color='whiteAlpha.800' fontSize='lg' maxW='lg' lineHeight='tall'>
							Connect a WordPress site, let Blogsmith learn your client&apos;s voice, then
							generate and schedule SEO posts with internal links — without leaving Ops Pilot.
						</Text>
						<VStack align={{ base: 'center', lg: 'start' }} spacing={2}>
							{[
								'Learns tone & topics from live site content',
								'One-off or recurring SEO post schedules',
								'Save as draft or publish straight to WordPress',
							].map((item) => (
								<HStack key={item} spacing={2}>
									<Icon as={FiCheckCircle} color='cyan.300' />
									<Text color='whiteAlpha.800' fontSize='sm' mb={0}>
										{item}
									</Text>
								</HStack>
							))}
						</VStack>
						<Button
							size='lg'
							bg='cyan.400'
							color='gray.900'
							rounded='full'
							px={8}
							rightIcon={<FiArrowRight />}
							_hover={{ bg: 'cyan.300', boxShadow: '0 8px 30px rgba(34,211,238,0.35)' }}
							onClick={onCta}>
							Choose your plan
						</Button>
					</VStack>

					<BlogsmithTypewriterDemo />
				</SimpleGrid>
			</Container>
		</Box>
	);
}
